export const STATUS = {
  SUCCESS: 'Éxito',
  ERROR: 'Falló',
  PENDING: 'Pendiente',
};

export type Status =
  'Falló' |
  'Éxito' |
  'Pendiente';
